import React, { useEffect } from 'react';
import { logger } from '../services/logger';

/**
 * Windows demonstration page
 * Showcases the window management system capabilities
 */
const WindowsPage: React.FC = () => {
  // Log page visit
  useEffect(() => {
    logger.info('Windows page visited');
  }, []);

  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
        <div className="p-4 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-2xl font-bold">Window Management System</h2>
        </div>
        <div className="p-4">
          <p className="text-gray-600 dark:text-gray-400 mb-4">
            This page demonstrates the window management system for the PhishPhind application. 
            The window system allows users to work with multiple analysis windows simultaneously.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <h3 className="font-semibold mb-2">Features:</h3>
              <ul className="list-disc pl-5 space-y-1">
                <li>Create multiple window types</li>
                <li>Drag windows to reposition</li>
                <li>Resize windows from edges and corners</li>
                <li>Minimize, maximize, and close windows</li>
                <li>Focus management (active window comes to front)</li>
                <li>State persistence through Redux store</li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold mb-2">Window Types:</h3>
              <ul className="list-disc pl-5 space-y-1">
                <li><strong>Editor</strong> - For viewing and editing email content</li>
                <li><strong>Results</strong> - For viewing analysis results</li>
                <li><strong>Settings</strong> - For configuring application settings</li>
                <li><strong>Help</strong> - For viewing documentation and help</li>
              </ul>
            </div>
          </div>
          
          <p className="text-sm bg-blue-50 dark:bg-blue-900/30 p-3 rounded-md border border-blue-100 dark:border-blue-800">
            <strong>Tip:</strong> The window management system is coming soon! This page will allow you to 
            create and manage multiple windows for different aspects of your analysis workflow.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WindowsPage; 